import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Box, Button, Autocomplete, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, IconButton, Menu, InputAdornment, OutlinedInput, Collapse, List, ListItem, ListItemText, RadioGroup, FormControlLabel, Radio, ListItemIcon, ToggleButtonGroup, ToggleButton, Chip, ClickAwayListener, createFilterOptions, Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogReuse from '../../ReuseComponents/DialogReuse';
import { LoadingButton } from '@mui/lab';
import { v4 as uuidv4 } from 'uuid';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useDispatch, useSelector } from 'react-redux';
import transformConditionsToExpression from '../../../../utils/transformConditionsToExpression';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import ConfirmDialogReuse from '../../ReuseComponents/ConfirmDialogReuse';
import { getSubjectSchema } from '../../../../redux/subjectSchemaSlice';
import { dataTypes } from '../../../../utils/configDataTypes';
import { createValidator } from '../../../../utils/postgresqlTypeValidator';
import { getCurrentDRG, setCurrentDRG } from '../../../../redux/drgMgtSlice';
import { syncRegulatoryFileState } from '../../../../utils/regulatoryFileSync';

const filter = createFilterOptions();

const getOperatorValue = (operator) => {
    if (!operator) return '';
    if (typeof operator === 'string') return operator;
    return operator.condition ?? '';
};

const getOperatorLabel = (operator) => {
    if (!operator) return '';
    if (typeof operator === 'string') return operator;
    return operator.label ?? operator.condition ?? '';
};

const getValidOperators = (operators = []) => {
    return operators.filter((operator) => {
        if (typeof operator === 'string') {
            return operator !== '';
        }
        return operator?.condition !== null && operator?.condition !== undefined && operator?.condition !== '';
    });
};

const findOperatorConfig = (operator, operators = []) => {
    const selectedOperator = getOperatorValue(operator);
    if (!selectedOperator) return null;

    const matchedOperator = getValidOperators(operators).find(
        (item) => getOperatorValue(item) === selectedOperator
    );

    if (matchedOperator) {
        return matchedOperator;
    }

    return typeof operator === 'object' ? operator : null;
};

const isMultipleOperator = (operator, operators = []) => {
    if (!operator) return false;

    const matchedOperator = findOperatorConfig(operator, operators);
    if (matchedOperator && typeof matchedOperator === 'object') {
        return !!matchedOperator.multiple;
    }

    const operatorValue = getOperatorValue(operator);
    return operatorValue === 'IN' || operatorValue === 'NOT IN';
};

const normalizeSingleConstantValue = (value) => {
    if (value === 'Empty String') {
        return '';
    }
    return value;
};

const getSingleConstantDisplayValue = (value) => {
    if (value === '') {
        return 'Empty String';
    }
    return value ?? null;
};

function NewCreateConditionDialog(props) {

    const otherOptions = ["NULL", "Empty String"];

    const { open, setOpen, selectedNode, setNodes, nodes, editingOuterIndex, conditions, setEditingOuterIndex } = props;

    const theme = useTheme();

    const [resourceAttribute, setResourceAttribute] = useState([]);
    const [resourceAttributeSelected, setResourceAttributeSelected] = useState(null);
    const [operator, setOperator] = useState('');
    const [value, setValue] = useState("");
    const [resource, setResource] = useState("");
    const [subjectAttributeSelected, setSubjectAttributeSelected] = useState(null);
    const [dpeConfig, setDpeConfig] = useState();
    const [disabled, setDisabled] = useState(true);
    const [subConditions, setSubConditions] = useState([]);

    const [openInputValue, setOpenInputValue] = useState(false);

    const [subjectAttributes, setSubjectAttributes] = useState([]);
    const [listParameters, setListParameters] = useState([]);

    const [newParameter, setNewParameter] = useState("");
    const [showInput, setShowInput] = useState(false);
    const [anchorElParameter, setAnchorElParameter] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [editValue, setEditValue] = useState("");
    const [menuIndex, setMenuIndex] = useState(null); // เก็บ index ของรายการที่กด MoreVertIcon
    const [isEditing, setIsEditing] = useState(false);
    const [errorAddParameter, setErrorAddParameter] = useState(false);
    const [errorEditParameter, setErrorEditParameter] = useState(false);

    const [selectedRadioIndex, setSelectedRadioIndex] = useState(null);
    const [selectedRadioGroup, setSelectedRadioGroup] = useState(""); // default เดิมเป็น null

    const [hasSelected, setHasSelected] = useState(true);

    const nodesRef = useRef(nodes);

    const [currentEdit, setCurrentEdit] = useState(null);

    const [constantMode, setConstantMode] = useState('single');
    const [constantSingleValue, setConstantSingleValue] = useState(null);
    const [constantMultipleValue, setConstantMultipleValue] = useState([]);

    const [inputValue, setInputValue] = useState(''); // Multiple Value

    const [constantType, setConstantType] = useState("string");
    const [confirmRemoveParameter, setConfirmRemoveParameter] = useState(false);
    const [confirmRemoveParameterMessage, setConfirmRemoveParameterMessage] = useState("This parameter is currently in use and cannot be deleted.");

    const [inputError, setInputError] = useState(null);
    const [valueError, setValueError] = useState(null);
    const [operatorSelected, setOperatorSelected] = useState(null);

    const [requiredParamter, setRequiredParamter] = useState(false)

    const dispatch = useDispatch();
    const regulatoryFile = useSelector(getCurrentDRG);
    const subjectSchema = useSelector(getSubjectSchema);

    useEffect(() => {
        const dpeConfig = JSON.parse(localStorage.getItem('dpe-config'));
        if (dpeConfig) {
            setDpeConfig(dpeConfig);
        }
    }, []);

    const handleClose = () => {
        setSubConditions([]);
        setResourceAttribute([]);
        setResourceAttributeSelected(null);
        setSubjectAttributeSelected(null)
        setOperator('');
        setValue();
        setOpen(false);
        setEditingOuterIndex(null);
    };

    const handleCreate = () => {
        const conditions = nodesRef.current.find(node => node.id === selectedNode.id)?.data?.general_properties?.conditions || [];
        let newConditions = [];

        if (editingOuterIndex === null) {

            let updatedConditions = conditions;
            if (conditions.length > 0) {
                updatedConditions = conditions.map((cond, i) => {
                    if (i === conditions.length - 1) {
                        return { ...cond, conjunction: "AND" };
                    }
                    return cond;
                });
            }

            newConditions = [...updatedConditions, { subConditions, conjunction: "" }];

        } else {

            newConditions = conditions.map((cond, i) => {
                if (i !== editingOuterIndex) return cond;
                return { ...cond, subConditions };
            });

        }

        const updatedParameters = handleUpdatedParameterConditions(newConditions);
        const UpdatedNodes = updatedParamters(updatedParameters);
        const expression = transformConditionsToExpression(updatedParameters);

        setNodes((prev) =>
            prev.map((node) => {
                if (node.id === selectedNode.id) {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            general_properties: {
                                ...node.data.general_properties,
                                conditions: updatedParameters,
                                expression: expression
                            }
                        }
                    };
                }
                if (UpdatedNodes.includes(node.id)) {
                    const updated_parameters = handleUpdatedParameterConditions(node.data.general_properties.conditions);
                    const updated_expression = transformConditionsToExpression(updated_parameters);
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            general_properties: {
                                ...node.data.general_properties,
                                conditions: updated_parameters,
                                expression: updated_expression
                            }
                        }
                    };
                }
                return node;
            })
        );

        handleClose();

    };

    const handleUpdatedParameterConditions = (newConditions) => {
        const updatedParameters = newConditions.map((sub, i) => {
            const updatedParametersValue = sub.subConditions.map((cond) => {
                if (cond.value_property?.value_type === "Parameter") {
                    return {
                        ...cond,
                        value_property: {
                            ...cond.value_property,
                            value: getParameterName(cond.value_property?.parameter_id),
                        },
                    };
                }
                return cond;
            });
            return { ...sub, subConditions: updatedParametersValue };
        });
        return updatedParameters;
    };

    const updatedParamters = (newConditions) => {
        const hasParameter = [];
        newConditions.forEach(sub => {
            sub.subConditions.forEach(cond => {
                if (cond.value_property?.value_type === "Parameter") {
                    hasParameter.push(cond.value_property?.parameter_id);
                }
            });
        });

        const checkDuplicate = [];
        hasParameter.forEach(item => {
            if (item && !checkDuplicate.includes(item) && item !== null) {
                checkDuplicate.push(item);
            }
        });

        const updated_parameters = listParameters.map((param) => {
            const used_with_node = param.used_with_node || [];
            const clearDuplicate = used_with_node.filter(nodeId => nodeId !== selectedNode.id); // ลบ node id ออกก่อน
            if (checkDuplicate.includes(param.id)) {
                return {
                    ...param,
                    used_with_node: [...clearDuplicate, selectedNode.id]
                };
            } else {
                return {
                    ...param,
                    used_with_node: clearDuplicate
                };
            }
        });

        // ERROR

        const changedParams = updated_parameters.filter(param => {
            const globalParameter = regulatoryFile?.parameters ? regulatoryFile?.parameters.find(p => p.id === param.id) : false;
            return globalParameter && globalParameter.value !== param.value;
        });

        const nodeIdsToUpdate = [
            ...new Set(
                changedParams.flatMap(param => param.used_with_node) // รวม node id ที่ใช้ parameter นี้
            )
        ].filter(nodeId => nodeId !== selectedNode.id); // ลบ selectedNode.id ออกถ้ามี

        const updatedRegulatoryFile = {
            ...regulatoryFile,
            parameters: updated_parameters
        };
        syncRegulatoryFileState({
            file: updatedRegulatoryFile,
            dispatch,
            setCurrentDRG,
            normalize: false,
        });

        return nodeIdsToUpdate;

    };

    const handleCloseInputValue = () => {
        setOpenInputValue(false);
        setNewParameter("");
        setShowInput(false);
        setErrorAddParameter(false);
        setAnchorElParameter(null);
        setMenuIndex(null);
        setEditIndex(null);
        setEditValue("");
        setIsEditing(false);
        setSelectedRadioIndex(null);
        setSelectedRadioGroup(""); // Reset to default
        setHasSelected(true);
        setConstantSingleValue(null);
        setConstantMultipleValue([]);
        setSubjectAttributeSelected(null);
        setConstantMode('single');
        setInputError(null);
        setValueError(null);
    };

    const handleSelectOption = (rootNode) => {
        const attributeSelection = rootNode?.data?.general_properties?.resource_schema || [];
        const selectedAttribute = attributeSelection.map(attr => {
            const attrType = attr.data_type;
            const foundType = dataTypes.find(dt => dt.similar_type.includes(attrType));
            return {
                ...attr,
                type: foundType ? foundType.type : 'string', // Default เป็น string ถ้าไม่พบ
                operators: foundType ? getValidOperators(foundType.operators) : []
            }
        });
        setResourceAttribute(selectedAttribute);
    };

    useEffect(() => {
        if (open) {
            const getSubjectSchema = subjectSchema || [];
            setSubjectAttributes(getSubjectSchema)
            const rootNode = nodesRef.current.find(node => node.type === 'root');
            setResource(rootNode.data?.general_properties?.resource || "Not found.");
            handleSelectOption(rootNode);
        }
    }, [open, nodesRef.current])

    useEffect(() => {
        nodesRef.current = nodes;
    }, [nodes])

    const handleAddCondition = (index) => {
        setSubConditions((prevConditions) => {
            const safePrevConditions = Array.isArray(prevConditions) ? prevConditions : [];
            const newConditions = safePrevConditions.map((cond, i) => {
                if (i === index) {
                    return { ...cond, conjunction: "AND" };
                }
                return cond;
            });

            newConditions.push({
                resourceAttribute: null,
                operator: '',
                value_property: '',
                conjunction: '',
            });

            return newConditions;
        });
    };

    const handleRemoveCondition = (index) => {
        setSubConditions(prev => {
            const safePrev = Array.isArray(prev) ? prev : [];
            const updated = safePrev.filter((_, i) => i !== index);

            // แถวสุดท้ายต้องไม่มี conjunction เสมอ
            if (updated.length > 0) {
                const lastIndex = updated.length - 1;
                updated[lastIndex] = { ...updated[lastIndex], conjunction: '' };
            }

            return updated;
        });
    };

    const handleChange = (index, field, value, type) => {
        let newValue = field === 'operator' ? getOperatorValue(value) : value;
        if (field === 'value_property' && type === "Constant") {
            newValue = {
                value: value,
                value_type: type,
                constant_mode: constantMode
            }
        } else if (field === 'value_property' && type === 'Subject') {
            newValue = {
                value: value || "",
                value_type: type,
            }
        } else if (field === 'value_property' && type === "Parameter") {
            newValue = {
                value: value.value,
                // value: getParameterName(value.id),
                value_type: type,
                parameter_id: value.id,
                required: requiredParamter
            }
        }

        setSubConditions(prev =>
            prev.map((cond, i) => {
                if (i !== index) return cond;

                // clone object ชั้นเดียว แล้วปรับค่า field
                let updated = {
                    ...cond,
                    [field]: newValue,
                };

                if (field === 'resourceAttribute') {
                    delete updated.attr_error_text;
                    return {
                        ...updated,
                        operator: '',
                        value_property: { value: '', value_type: '' },
                    };
                }

                if (field === 'operator') {
                    delete updated.operator_error_text;

                    const previousValueProperty = cond?.value_property;
                    if (!previousValueProperty || typeof previousValueProperty !== 'object') {
                        return updated;
                    }

                    // Keep selected value when operator changes. Only normalize
                    // constant shape if operator switches between single/multiple.
                    if (previousValueProperty?.value_type !== 'Constant') {
                        return {
                            ...updated,
                            value_property: previousValueProperty,
                        };
                    }

                    const nextIsMultiple = isMultipleOperator(newValue, cond?.resourceAttribute?.operators);
                    const prevConstantValue = previousValueProperty?.value;
                    let normalizedConstantValue = prevConstantValue;

                    if (nextIsMultiple) {
                        if (Array.isArray(prevConstantValue)) {
                            normalizedConstantValue = prevConstantValue;
                        } else if (prevConstantValue === '' || prevConstantValue === null || prevConstantValue === undefined) {
                            normalizedConstantValue = [];
                        } else {
                            normalizedConstantValue = [prevConstantValue];
                        }
                    } else if (Array.isArray(prevConstantValue)) {
                        normalizedConstantValue = prevConstantValue.length > 0 ? prevConstantValue[0] : '';
                    }

                    return {
                        ...updated,
                        value_property: {
                            ...previousValueProperty,
                            value: normalizedConstantValue,
                            constant_mode: nextIsMultiple ? 'multiple' : 'single',
                        },
                    };
                }

                if (field === 'value_property') {
                    delete updated.data_type_error_text;
                }

                return updated;
            })
        );
    };

    const handleOpenInputValue = (index) => {
        setOpenInputValue(true);
        setCurrentEdit(index);
    };

    const handleAddClick = () => {
        setShowInput(true); // Show input for new parameter
    };

    const handleInputChange = (event) => {
        setNewParameter(event.target.value);
        setErrorAddParameter(false);
    };

    const handleInputBlur = () => {
        const trimmedValue = newParameter.trim();

        if (!trimmedValue) {
            // ถ้าเป็นค่าว่างให้ยกเลิกการเพิ่ม
            setNewParameter("");
            setShowInput(false);
            setErrorAddParameter(false);
            return;
        }

        if (/\s/.test(trimmedValue)) {
            // ถ้ามีช่องว่างให้แจ้งเตือน error
            // setErrorAddParameter(true);
            setErrorAddParameter("Parameter name cannot be empty or contain spaces.");
            return;
        }

        const sqlInjectionPattern = /(\b(SELECT|UNION|INSERT|UPDATE|DELETE|DROP|ALTER|EXEC|CREATE|TRUNCATE|RENAME|MERGE|DECLARE|GRANT|REVOKE)\b|(--|#|;|\'|\"|\/\*|\*\/)|\bOR\b(?![a-zA-Z0-9-]*\.[a-zA-Z]{2,})|\bAND\b(?![a-zA-Z0-9-]*\.[a-zA-Z]{2,}))/gi;
        if (sqlInjectionPattern.test(trimmedValue)) {
            setErrorAddParameter("Inappropriate parameter.");
            return; // พบคำสั่ง SQL ที่เป็นอันตราย -> ถือว่า "มีปัญหา" หรือ รูปแบบ email ไม่ถูกต้อง
        }

        if (newParameter.trim()) {
            // Check for duplicates before adding
            const isDuplicate = listParameters.some(param => param.value === newParameter);
            if (isDuplicate) {
                setErrorAddParameter("Parameter name is duplicated."); // Set error if duplicate
                return; // Don't add if duplicate
            } else {
                setErrorAddParameter(false); // Clear error if not duplicate

                const updatedParameters = [...listParameters, {
                    id: uuidv4(),
                    value: newParameter,
                    value_type: "Parameter",
                    used_with_node: [],
                }];

                setListParameters(updatedParameters);

            }
        }
        setNewParameter(""); // Clear input field
        setShowInput(false); // Hide input after adding
    };

    const handleInputKeyDown = (event) => {
        if (event.key === "Enter" && newParameter.trim()) {
            handleInputBlur();
        }
    };

    const handleParameterMenuOpen = (event, index) => {
        setAnchorElParameter(event.currentTarget);
        setMenuIndex(index);
    };

    const handleParameterMenuClose = () => {
        setAnchorElParameter(null);
        setMenuIndex(null);
    };

    const handleEditStart = (index) => {
        setAnchorElParameter(null); // Close menu before editing
        setMenuIndex(null); // ปิดเมนู
        setEditIndex(index); // เปลี่ยน index ที่ต้องการแก้ไข
        setEditValue(listParameters[index]?.value || ""); // ใส่ค่าเดิมของ item นั้น
        setIsEditing(true);
    };

    const handleEditChange = (event) => {
        setEditValue(event.target.value);
        setErrorEditParameter(false); // ถ้ามีช่องว่างจะเป็น true เพื่อให้ TextField เป็นสีแดง
    };

    const handleEditSave = () => {
        if (!editValue.trim() || /\s/.test(editValue.trim())) {
            setErrorEditParameter(true);
            return; // หยุดการบันทึกถ้ามีช่องว่าง
        }

        // const isDuplicate = listParameters.some(param => param.value === editValue.trim());
        // if (isDuplicate) {
        //     setErrorEditParameter(true); // Set error if duplicate
        //     return; // Don't add if duplicate
        // }

        setListParameters(prev => prev.map((param, i) => (i === editIndex ? { ...param, value: editValue } : param)));

        setEditIndex(null);
        setErrorEditParameter(false); // ล้าง error หลังจากแก้ไขสำเร็จ
        setIsEditing(false);  // ปิดสถานะการแก้ไข
    };

    const handleEditBlur = () => {
        // const isDuplicate = listParameters.some(param => param.value === editValue.trim());
        // if (isDuplicate) {
        //     setErrorEditParameter(true); // Set error if duplicate
        //     return; // Don't add if duplicate
        // }

        if (!editValue.trim() || /\s/.test(editValue.trim())) {
            setErrorEditParameter("Parameter name cannot be empty or contain spaces.");
            return; // หยุดการบันทึกถ้ามีช่องว่าง
        }

        const sqlInjectionPattern = /(\b(SELECT|UNION|INSERT|UPDATE|DELETE|DROP|ALTER|EXEC|CREATE|TRUNCATE|RENAME|MERGE|DECLARE|GRANT|REVOKE)\b|(--|#|;|\'|\"|\/\*|\*\/)|\bOR\b(?![a-zA-Z0-9-]*\.[a-zA-Z]{2,})|\bAND\b(?![a-zA-Z0-9-]*\.[a-zA-Z]{2,}))/gi;
        if (sqlInjectionPattern.test(editValue.trim())) {
            setErrorEditParameter("Inappropriate parameter.");
            return; // พบคำสั่ง SQL ที่เป็นอันตราย -> ถือว่า "มีปัญหา" หรือ รูปแบบ email ไม่ถูกต้อง
        }

        setIsEditing(false);
        setErrorEditParameter(false); // ล้าง error

        if (!isEditing) {
            if (editValue.trim() !== listParameters[editIndex]?.value) {
                handleEditSave();  // บันทึกการแก้ไขหากชื่อมีการเปลี่ยนแปลง
            } else {
                setEditIndex(null);  // หากไม่เปลี่ยนแปลงให้รีเซ็ต
                setErrorEditParameter(false); // ล้าง error
                // return;
            }
        }
    };

    const handleEditKeyDown = (event) => {
        if (event.key === "Enter") {
            handleEditSave();
        }
    };

    const isParameterUsedInConditions = (nodeConditions = [], parameterId) => {
        return nodeConditions.some((group) =>
            (group?.subConditions || []).some((cond) =>
                cond?.value_property?.value_type === "Parameter" &&
                cond?.value_property?.parameter_id === parameterId
            )
        );
    };

    const hasOtherNodeUsingParameter = (parameterId) => {
        return (nodesRef.current || []).some((node) => {
            if (node.id === selectedNode?.id) {
                return false;
            }

            const nodeConditions = node?.data?.general_properties?.conditions || [];
            return isParameterUsedInConditions(nodeConditions, parameterId);
        });
    };

    const clearParameterFromConditions = (conditions = [], parameterId) => {
        let hasChanged = false;

        const updatedConditions = conditions.map((group) => ({
            ...group,
            subConditions: (group?.subConditions || []).map((cond) => {
                const isTargetParam =
                    cond?.value_property?.value_type === "Parameter" &&
                    cond?.value_property?.parameter_id === parameterId;

                if (!isTargetParam) {
                    return cond;
                }

                hasChanged = true;
                return {
                    ...cond,
                    value_property: {
                        value: '',
                        value_type: ''
                    }
                };
            })
        }));

        return { updatedConditions, hasChanged };
    };

    // const handleDelete = (index) => {
    //     const checkDelete = listParameters[index]?.used_with_node || [];
    //     if (checkDelete.length > 0) {
    //         setConfirmRemoveParameter(true);
    //     } else {
    //         setListParameters(prev => prev.filter((_, i) => i !== index));
    //     }
    //     setAnchorElParameter(null);
    //     setMenuIndex(null);
    //     setEditIndex(null);
    //     setEditValue("");
    // };

    const handleDelete = (index) => {
        const parameterToDelete = listParameters[index];

        if (!parameterToDelete) {
            return;
        }

        const isSelectedInRadio =
            selectedRadioGroup === "parameter" &&
            selectedRadioIndex === parameterToDelete.id;

        if (hasOtherNodeUsingParameter(parameterToDelete.id)) {
            setConfirmRemoveParameterMessage("This parameter is currently used by another node and cannot be deleted.");
            setConfirmRemoveParameter(true);
        } else {
            if (isSelectedInRadio) {
                setSelectedRadioIndex(null);
                setSelectedRadioGroup("");
                setHasSelected(true);
            }

            const { updatedConditions, hasChanged } = clearParameterFromConditions([{ subConditions }], parameterToDelete.id);
            if (hasChanged) {
                setSubConditions(updatedConditions[0]?.subConditions || []);
            }

            setListParameters(prev => prev.filter((_, i) => i !== index));
        }

        setAnchorElParameter(null);
        setMenuIndex(null);
        setEditIndex(null);
        setEditValue("");
    };

    const handleRadioChange = (group, index) => {
        setSelectedRadioGroup(group);

        if (group === "constant") {
            setSelectedRadioIndex(null);
            setSubjectAttributeSelected(null);
            setRequiredParamter(false);

            if (constantMode === 'single') {
                setConstantMultipleValue([]);

                if (
                    constantType?.toLowerCase() === "string" &&
                    constantSingleValue === null
                ) {
                    setConstantSingleValue('');
                }
            } else {
                setConstantSingleValue(null);
            }

            return;
        }

        if (group === "subject") {
            setSelectedRadioIndex(null);
            setConstantSingleValue(null);
            setConstantMultipleValue([]);
            setInputValue('');
            setInputError(null);
            setValueError(null);
            setRequiredParamter(false);
            return;
        }

        if (group === "parameter") {
            setSelectedRadioIndex(index ?? null);
            setSubjectAttributeSelected(null);
            setConstantSingleValue(null);
            setConstantMultipleValue([]);
            setInputValue('');
            setInputError(null);
            setValueError(null);
            return;
        }

        setSelectedRadioIndex(null);
    };

    const hasValidConstantSelection = () => {
        if (inputError !== null || valueError !== null) {
            return false;
        }

        if (constantMode === 'multiple') {
            return normalizeMultipleValues(constantMultipleValue).length > 0;
        }

        if (constantType?.toLowerCase() === 'string') {
            return constantSingleValue !== null && constantSingleValue !== '';
        }

        if (constantType?.toLowerCase() === 'boolean') {
            return constantSingleValue === true || constantSingleValue === false;
        }

        return constantSingleValue !== null && constantSingleValue !== '';
    };

    const hasValidSubjectSelection = () => {
        return typeof subjectAttributeSelected === 'string' && subjectAttributeSelected !== '';
    };

    const hasValidParameterSelection = () => {
        return selectedRadioIndex !== null && editIndex === null &&
            listParameters.some((param) => param.id === selectedRadioIndex);
    };

    const normalizeMultipleValues = (value) => {
        if (Array.isArray(value)) {
            return value;
        }
        return [];
    };

    const normalizeSubConditions = (value) => {
        return Array.isArray(value) ? value : [];
    };

    const validateAndParseConstantValue = (rawValue, pgType, isMultipleMode) => {
        let typeValidator;

        try {
            typeValidator = createValidator(pgType);
        } catch (error) {
            return {
                valid: false,
                parsed: null,
                error: error?.message || 'Unsupported data type'
            };
        }

        if (isMultipleMode) {
            const values = normalizeMultipleValues(rawValue);

            if (values.length === 0) {
                return {
                    valid: false,
                    parsed: null,
                    error: `Invalid ${constantType} value`
                };
            }

            // Array-typed attributes are validated as a whole array value.
            if (typeValidator.type === 'array') {
                const validateArrayResult = typeValidator.validate(values);
                return {
                    valid: validateArrayResult.valid,
                    parsed: validateArrayResult.valid ? validateArrayResult.parsed : null,
                    error: validateArrayResult.valid ? null : validateArrayResult.error
                };
            }

            const parsedValues = [];

            for (let i = 0; i < values.length; i += 1) {
                const item = values[i];
                const validateItemResult = typeValidator.validate(item);

                if (!validateItemResult.valid) {
                    return {
                        valid: false,
                        parsed: null,
                        error: `${validateItemResult.error} at item ${i + 1}`
                    };
                }

                parsedValues.push(validateItemResult.parsed);
            }

            return {
                valid: true,
                parsed: parsedValues,
                error: null
            };
        }

        const validateResult = typeValidator.validate(rawValue);
        return {
            valid: validateResult.valid,
            parsed: validateResult.valid ? validateResult.parsed : null,
            error: validateResult.valid ? null : validateResult.error
        };
    };

    const handleChooseValue = () => {
        let newValue;
        let value_type;
        let isValidInput = true;
        if (selectedRadioGroup === "parameter") {
            const value = listParameters.find((param) => param.id === selectedRadioIndex); // { id, value, value_type, used_with_node }
            newValue = value;
            value_type = "Parameter"
        } else if (selectedRadioGroup === "subject") {
            newValue = subjectAttributeSelected;
            value_type = "Subject"
        } else if (selectedRadioGroup === "constant") {
            if (constantMode === 'single') {
                newValue = normalizeSingleConstantValue(constantSingleValue);
            } else {
                newValue = constantMultipleValue;
            }
            value_type = "Constant"

            if (
                constantMode === 'single' &&
                constantType?.toLowerCase() !== 'string' &&
                newValue === ''
            ) {
                setValueError(`Invalid ${constantType} value`);
                isValidInput = false;
            }

            if (!isValidInput) {
                return;
            }

            const validateResult = validateAndParseConstantValue(
                newValue,
                subConditions[currentEdit]?.resourceAttribute?.data_type,
                constantMode === 'multiple'
            );

            // console.log("Validation Result:", validateResult); // Debug log

            if (!validateResult.valid) {
                setValueError(validateResult.error || `Invalid ${constantType} value`);
                isValidInput = false;
            } else {
                newValue = validateResult.parsed; // ใช้ค่าที่ถูกแปลงแล้วจาก validator
                setValueError(null);
            }
        }

        if (isValidInput) {
            handleChange(currentEdit, "value_property", newValue, value_type);
            handleCloseInputValue();
        }
    };

    useEffect(() => {
        if (selectedRadioGroup === "constant" && hasValidConstantSelection()) {
            setHasSelected(false);
        } else if (selectedRadioGroup === "subject" && hasValidSubjectSelection()) {
            setHasSelected(false);
        } else if (selectedRadioGroup === "parameter" && hasValidParameterSelection()) {
            setHasSelected(false);
        } else {
            setHasSelected(true);
        }
    }, [selectedRadioIndex, selectedRadioGroup, constantMode, constantType, constantSingleValue, constantMultipleValue, subjectAttributeSelected, editIndex, inputError, valueError, listParameters]);

    useEffect(() => {
        if (open || regulatoryFile) {
            const parameters = regulatoryFile?.parameters || [];
            setListParameters(parameters);
        }
    }, [open, regulatoryFile]);

    useEffect(() => {
        function hasInvalidCondition(subConditions) {
            return subConditions.some(({ resourceAttribute, operator, value_property }) => {
                if (!resourceAttribute || Object.keys(resourceAttribute).length === 0) return true;
                if (operator === "") return true;
                if (Array.isArray(value_property.value) && value_property.value.length === 0) return true;
                if (value_property.value === "") {
                    // Allow empty string constant when attribute type is string and operator is set
                    if (resourceAttribute?.type?.toLowerCase() === 'string' && operator !== "") return false;
                    return true;
                }
                return false;
            });
        }
        if (subConditions) {
            const isValid = hasInvalidCondition(subConditions);
            setDisabled(isValid);
        }
    }, [subConditions])

    // // ฟังก์ชันตรวจสอบและแปลงค่าที่เป็น 'null' ให้เป็น 'NULL'
    // const normalizeValue = (value) => {
    //     if (typeof value === 'string' && value.trim().toLowerCase() === 'null') {
    //         return 'NULL';
    //     }
    //     return value;
    // };

    const handleAddChip = () => {
        let newValue = inputValue.trim();
        if (newValue === '') return;

        const safeMultipleValues = normalizeMultipleValues(constantMultipleValue);

        // newValue = normalizeValue(newValue);

        // if (newValue === 'NULL') {
        //     if (!constantMultipleValue.includes('NULL')) {
        //         setConstantMultipleValue([...constantMultipleValue, newValue]);
        //     }
        //     // เคลียร์ input field ไม่ว่าค่า 'NULL' จะเป็น duplicate หรือไม่
        //     setInputValue('');
        //     return;
        // }

        // กรณีค่าอื่นๆ
        if (!safeMultipleValues.includes(newValue)) {
            setConstantMultipleValue([...safeMultipleValues, newValue]);
        }
        // เคลียร์ input field ในกรณี duplicate หรือไม่
        setInputValue('');

        if (hasSpecialCharacters(newValue)) {
            setInputError("Special characters are not allowed");
            setValueError("Special characters are not allowed");
            return;
        } else if (!isValidType(newValue)) {
            setInputError(`Invalid ${constantType} value`);
            setValueError(`Invalid ${constantType} value`);
            return;
        } else {
            setInputError(null);
            setValueError(null);
        }
    };

    const handleDeleteChip = (indexToDelete) => {
        const safeMultipleValues = normalizeMultipleValues(constantMultipleValue);
        const updatedValues = safeMultipleValues.filter((_, i) => i !== indexToDelete);
        setConstantMultipleValue(updatedValues);
    };

    const handleAutoCompleteChange = (event, newValue, reason) => {
        if (reason === 'clear') {
            setConstantMultipleValue([]);
            setInputValue('');
            setValueError(null);
            return;
        }

        const normalizedValues = normalizeMultipleValues(newValue);

        setConstantMultipleValue(normalizedValues);

        if (normalizedValues.some((val) => hasSpecialCharacters(String(val)))) {
            setValueError("Special characters are not allowed");
        } else if (normalizedValues.some((val) => !isValidType(val))) {
            setValueError(`Invalid ${constantType} value`);
        } else {
            setValueError(null);
        }

    };

    const handleDateChange = (newValue) => {
        if (newValue && dayjs(newValue).isValid()) {
            // ISO 8601 format for date: YYYY-MM-DD
            const formatted = dayjs(newValue).format('YYYY-MM-DD');
            setConstantSingleValue(formatted);
        } else {
            setConstantSingleValue('');
        }
    };

    const handleDateTimeChange = (newValue) => {
        if (newValue && dayjs(newValue).isValid()) {
            const formatted = dayjs(newValue).format('YYYY-MM-DD HH:mm:ss');
            // console.log("Formatted DateTime:", formatted); // Debug log
            setConstantSingleValue(formatted);
        } else {
            setConstantSingleValue('');
        }
    };

    useEffect(() => {
        const initialConditionData = {
            conjunction: '', // conjunction ที่ใช้กับ outer condition (ถ้ามี)
            subConditions: [
                {
                    resourceAttribute: null,
                    operator: '',
                    value_property: '',
                    conjunction: '' // conjunction สำหรับ sub condition ถ้าเพิ่มมากกว่า 1
                }
            ]
        };
        if (editingOuterIndex !== null && open) {
            const normalizedConditions = normalizeSubConditions(conditions[editingOuterIndex]?.subConditions).map((condition) => ({
                ...condition,
                operator: getOperatorValue(condition?.operator),
            }));
            setSubConditions(normalizedConditions);
        } else {
            setSubConditions(initialConditionData.subConditions);
        }
    }, [editingOuterIndex, open])

    useEffect(() => {
        if (!openInputValue || currentEdit === null) {
            return;
        }

        const safeSubConditions = normalizeSubConditions(subConditions);
        const currentCondition = safeSubConditions[currentEdit];
        if (!currentCondition) {
            return;
        }

        const valueType = currentCondition?.value_property?.value_type || "";
        const resourceType = currentCondition?.resourceAttribute?.data_type || currentCondition?.resourceAttribute?.type || "string";
        const normalizedOperator = getOperatorValue(currentCondition?.operator);
        const isMultipleMode =
            isMultipleOperator(currentCondition?.operator, currentCondition?.resourceAttribute?.operators) ||
            resourceType.toLowerCase() === 'array';

        setSelectedRadioGroup("");
        setSelectedRadioIndex(null);
        setConstantSingleValue(null);
        setConstantMultipleValue([]);
        setSubjectAttributeSelected(null);
        setRequiredParamter(false);

        if (resourceType.toLowerCase() === dataTypes.find(dt => dt.type === "string")?.similar_type?.find(type => type.toLowerCase() === resourceType.toLowerCase())) {
            setConstantType("string");
        } else if (resourceType.toLowerCase() === dataTypes.find(dt => dt.type === "number")?.similar_type?.find(type => type.toLowerCase() === resourceType.toLowerCase())) {
            setConstantType("number");
        } else {
            setConstantType(resourceType);
        }

        setConstantMode(isMultipleMode ? 'multiple' : 'single');
        setOperatorSelected(isMultipleMode ? normalizedOperator : null);

        if (valueType === "Constant") {
            setSelectedRadioGroup("constant");

            if (Array.isArray(currentCondition?.value_property?.value) || isMultipleMode) {
                setConstantMultipleValue(normalizeMultipleValues(currentCondition?.value_property?.value));
            } else {
                const constantValue = getSingleConstantDisplayValue(currentCondition?.value_property?.value);
                setConstantSingleValue(constantValue);
            }
        } else if (valueType === "Subject") {
            setSelectedRadioGroup("subject");
            setSelectedRadioIndex(undefined);
            setSubjectAttributeSelected(currentCondition?.value_property?.value || "");
        } else if (valueType === "Parameter") {
            setSelectedRadioGroup("parameter");
            setSelectedRadioIndex(currentCondition?.value_property?.parameter_id);
            setRequiredParamter(!!currentCondition?.value_property?.required);
        }
    }, [openInputValue, subConditions, currentEdit])

    const getParameterName = (parameterId) => {
        const parameter_local = listParameters || [];
        return parameter_local.find(param => param.id === parameterId)?.value || "Not found";
    };

    const hasSpecialCharacters = (str) => /[^\p{L}\p{N}\s.-]/u.test(str);

    const isValidType = (val) => {
        // Empty string is valid for string/character types
        if (val === '' || val === null || val === undefined) {
            return true;
        }

        if (constantType?.toLowerCase() === "number") {
            return Array.isArray(val)
                ? val.every((v) => v !== '' && !isNaN(Number(v)))
                : val !== '' && !isNaN(Number(val));
        }
        return true;
    };

    const handleCheckBoxRequireParameter = (e) => {
        setRequiredParamter(e.target.checked)
    };

    const isSQLInjection = (str) => {
        const sqlInjectionPattern = /(\b(SELECT|UNION|INSERT|UPDATE|DELETE|DROP|ALTER|EXEC|CREATE|TRUNCATE|RENAME|MERGE|DECLARE|GRANT|REVOKE)\b|(--|#|;|\'|\"|\/\*|\*\/)|\bOR\b(?![a-zA-Z0-9-]*\.[a-zA-Z]{2,})|\bAND\b(?![a-zA-Z0-9-]*\.[a-zA-Z]{2,}))/gi;
        if (sqlInjectionPattern.test(str)) {
            return true; // พบคำสั่ง SQL ที่เป็นอันตราย -> ถือว่า "มีปัญหา" หรือ รูปแบบ email ไม่ถูกต้อง
        }
        return false;
    }

    return (
        <Fragment>

            <DialogReuse // New Create Condition
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={"md"}
                title={"Condition"}
                content={
                    <div className='min-h-[calc(100vh-300px)]'>

                        <Typography variant="subtitle2" display="block" gutterBottom>Resource</Typography>
                        <Typography variant='subtitle1' mt={-1} mb={4}>{resource}</Typography>

                        {normalizeSubConditions(subConditions).map((cond, index) => {
                            return (
                                <div key={index} className='w-full grid grid-cols-[28%_15%_34%_10%_7%] gap-4 mb-4'>

                                    <Box>
                                        <Autocomplete
                                            id="combo-box"
                                            size='small'
                                            fullWidth
                                            options={resourceAttribute}
                                            getOptionLabel={(option) => option.name}
                                            value={cond?.resourceAttribute}
                                            onChange={(event, newValue) => handleChange(index, "resourceAttribute", newValue)}
                                            renderValue={(value) => (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1 }}>
                                                    <span style={{
                                                        textDecoration: cond.attr_error_text === 'Attribute no longer available. Please select another.' ? 'line-through' : 'none',
                                                        color: cond.attr_error_text === 'Attribute no longer available. Please select another.' ? theme.palette.error.main : 'inherit',
                                                    }}>{value?.name}</span>
                                                    {value?.data_type && (
                                                        <Chip
                                                            label={value.data_type}
                                                            size="small"
                                                            sx={{
                                                                fontSize: '0.6rem',
                                                                textDecoration: cond.attr_error_text ? 'line-through' : 'none',
                                                                color: cond.attr_error_text ? 'error.main' : 'default',
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Resource Attribute"
                                                    error={!!cond?.attr_error_text}
                                                    helperText={cond?.attr_error_text || ""}
                                                />
                                            )}
                                            renderOption={(props, option) => {
                                                const { key, ...rest } = props;
                                                return (
                                                    <Box key={key} component="li" {...rest} display="flex" justifyContent="space-between" alignItems="center">
                                                        <span>{option.name}</span>
                                                        <Chip
                                                            label={option.data_type}
                                                            size="small"
                                                            sx={{ fontSize: '0.6rem', ml: 1 }}
                                                        />
                                                    </Box>
                                                );
                                            }}
                                        />
                                    </Box>

                                    <Box>
                                        <FormControl
                                            size="small"
                                            fullWidth
                                            disabled={!cond.resourceAttribute}
                                            error={!!cond?.operator_error_text}
                                        >
                                            <InputLabel>Operator</InputLabel>
                                            <Select
                                                label="Operator"
                                                value={getOperatorValue(cond.operator)}
                                                onChange={(e) => handleChange(index, "operator", e.target.value)}
                                                autoWidth
                                                sx={{
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {getValidOperators(cond.resourceAttribute?.operators || []).map((opt, idx) => (
                                                    <MenuItem key={idx} value={getOperatorValue(opt)}>{getOperatorLabel(opt)}</MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText>{cond?.operator_error_text || ""}</FormHelperText>
                                        </FormControl>
                                    </Box>

                                    <Box>
                                        <TextField
                                            id="condition-value"
                                            label={cond.value_property?.value_type || "Value"}
                                            variant="outlined"
                                            size='small'
                                            fullWidth
                                            onClick={() => handleOpenInputValue(index)}
                                            disabled={!cond.operator}
                                            value={cond.value_property?.value_type === "Parameter"
                                                ? getParameterName(cond.value_property?.parameter_id)
                                                : cond.value_property?.value_type === "Constant"
                                                    ? getSingleConstantDisplayValue(cond.value_property?.value) ?? ""
                                                    : (cond.value_property?.value ?? "")}
                                            InputLabelProps={{
                                                shrink: cond.value_property?.value_type === "Constant"
                                                    ? getSingleConstantDisplayValue(cond.value_property?.value) !== ""
                                                    && getSingleConstantDisplayValue(cond.value_property?.value) !== null
                                                    && getSingleConstantDisplayValue(cond.value_property?.value) !== undefined
                                                    : (cond.value_property?.value !== "" && cond.value_property?.value !== null && cond.value_property?.value !== undefined)
                                            }}
                                            slotProps={{ input: { readOnly: true } }}
                                            error={cond?.data_type_error_text ? true : false}
                                            helperText={cond?.data_type_error_text || ""}
                                        />
                                    </Box>

                                    {/* Add / Conjunction Select */}
                                    <Box>
                                        {index === normalizeSubConditions(subConditions).length - 1 ? (
                                            <Button
                                                sx={{
                                                    height: "40px",
                                                    // minWidth: "50px", // ปรับให้กว้างเท่า Select
                                                    width: "100%",
                                                    justifyContent: "center",
                                                }}
                                                variant="contained"
                                                startIcon={<AddIcon />}
                                                onClick={() => handleAddCondition(index)}
                                            >
                                                Add
                                            </Button>
                                        ) : (
                                            <FormControl
                                                size="small"
                                                sx={{
                                                    // minWidth: "50px",
                                                    width: "100%",
                                                }}
                                            >
                                                <Select
                                                    value={cond.conjunction}
                                                    onChange={(e) => handleChange(index, "conjunction", e.target.value)}
                                                >
                                                    <MenuItem value="AND">AND</MenuItem>
                                                    <MenuItem value="OR">OR</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )}
                                    </Box>

                                    {/* Delete Button */}
                                    {normalizeSubConditions(subConditions).length > 1 && (
                                        <Box>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    height: "40px",  // ให้สูงเท่า TextField
                                                    borderRadius: "4px",
                                                    minWidth: "40px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "4px",
                                                    borderColor: "rgba(0, 0, 0, 0.23)", // สีขอบเหมือน TextField
                                                    backgroundColor: "white",
                                                    "&:hover": {
                                                        color: "black", // ไอคอนสีเข้มขึ้น
                                                        backgroundColor: "rgba(0, 0, 0, 0.05)", // พื้นหลังขาวแต่ทึบขึ้นเล็กน้อย
                                                    },
                                                    // marginLeft: "14px", // ระยะห่างจากปุ่ม Add
                                                }}
                                                onClick={() => handleRemoveCondition(index)}
                                            >
                                                <DeleteIcon fontSize="small" color="action" />
                                            </Button>
                                        </Box>
                                    )}

                                </div>
                            )
                        })}

                    </div>
                }
                actions={
                    <LoadingButton variant="contained" disabled={disabled} onClick={() => handleCreate()}>
                        Confirm
                    </LoadingButton>
                }
            />

            <DialogReuse // Input Value
                open={openInputValue}
                onClose={handleCloseInputValue}
                fullWidth={true}
                maxWidth={"sm"}
                title={"Choose Parameters or Subject value"}
                contentNonePadding={true}
                content={
                    <Box
                        className="max-h-[calc(100vh-200px)] min-h-[calc(100vh-200px)]"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                        }}
                    >
                        <Box flexShrink={0}>
                            {/* Constant List */}
                            <ListItem
                                className='bg-gray-200'
                                sx={{
                                    padding: '5px 5px 5px 16px',
                                }}
                            >
                                <ListItemText primary="Constant" />
                            </ListItem>

                            <ListItem sx={{ paddingY: "10px" }}>
                                <ListItemIcon sx={{ minWidth: "auto", marginRight: "5px" }}>
                                    <Radio
                                        size="small"
                                        checked={selectedRadioGroup === "constant"}
                                        onChange={() => handleRadioChange("constant")}
                                    />
                                </ListItemIcon>
                                {constantType?.toLowerCase() === "boolean" ? (
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            labelId="select-value"
                                            value={constantSingleValue}
                                            onChange={(event) => {
                                                setConstantSingleValue(event.target.value);
                                            }}
                                            sx={{ justifyContent: "center", alignItems: "center" }}
                                            disabled={selectedRadioGroup !== "constant"}
                                        >
                                            <MenuItem value={true}>True</MenuItem>
                                            <MenuItem value={false}>False</MenuItem>
                                        </Select>
                                    </FormControl>
                                ) : constantType?.toLowerCase() === "timestamp with time zone" ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
                                        <FormControl size="small" fullWidth>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DateTimePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    ampm={false}
                                                    timeSteps={{ minutes: 1 }}
                                                    slotProps={{
                                                        textField: {
                                                            size: 'small',
                                                            inputProps: {
                                                                readOnly: true // ป้องกันการพิมพ์
                                                            },
                                                            error: !!valueError,
                                                            helperText: valueError || "",
                                                        }
                                                    }}
                                                    disabled={selectedRadioGroup !== "constant"}
                                                    value={
                                                        constantSingleValue
                                                            ? dayjs.isDayjs(constantSingleValue)
                                                                ? constantSingleValue
                                                                : dayjs(constantSingleValue, 'YYYY-MM-DD HH:mm:ss')
                                                            : null
                                                    }
                                                    onChange={handleDateTimeChange}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Box>
                                ) : constantType?.toLowerCase() === "date" ? (
                                    <FormControl size="small" fullWidth>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                format="YYYY-MM-DD"
                                                slotProps={{
                                                    textField: {
                                                        size: 'small',
                                                        inputProps: {
                                                            readOnly: true // ป้องกันการพิมพ์
                                                        },
                                                        error: !!valueError,
                                                        helperText: valueError || "",
                                                    }
                                                }}
                                                disabled={selectedRadioGroup !== "constant"}
                                                value={constantSingleValue ? dayjs(constantSingleValue) : null}
                                                onChange={handleDateChange}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                ) : (operatorSelected === "IN" || operatorSelected === "NOT IN" || constantType?.toLowerCase() === "array") ? (
                                    <Autocomplete
                                        id="constant-multiple-combo-box"
                                        size='small'
                                        multiple
                                        freeSolo
                                        fullWidth
                                        disabled={selectedRadioGroup !== "constant"}
                                        options={[]}
                                        value={normalizeMultipleValues(constantMultipleValue)}
                                        inputValue={typeof inputValue === 'string' ? inputValue : ''}
                                        onChange={handleAutoCompleteChange}
                                        onInputChange={(event, newInputValue, reason) => {
                                            setInputValue(newInputValue);
                                            if (reason === "input") {
                                                if (hasSpecialCharacters(newInputValue)) {
                                                    setInputError("Special characters are not allowed");
                                                } else if (!isValidType(newInputValue)) {
                                                    setInputError(`Invalid ${constantType} value`);
                                                } else {
                                                    setInputError(null);
                                                }
                                            } else if (newInputValue === '') {
                                                setInputError(null);
                                            }
                                        }}
                                        filterOptions={(options, params) => {
                                            const filtered = filter(options, params);
                                            const { inputValue } = params;
                                            if (
                                                inputValue !== '' &&
                                                !options.includes(inputValue) &&
                                                !normalizeMultipleValues(constantMultipleValue).includes(inputValue)
                                            ) {
                                                filtered.push(inputValue);
                                            }
                                            return filtered;
                                        }}
                                        renderOption={(props, option) => {
                                            if (option === inputValue) {
                                                return <li {...props} key={"add"}>Add "{option}"</li>;
                                            }
                                            return <li {...props} key={"etc"}>{option}</li>;
                                        }}
                                        renderTags={(value, getTagProps) => {
                                            const safeValue = normalizeMultipleValues(value);

                                            return safeValue.map((chip, index) => {
                                                const { key, ...tagProps } = getTagProps({ index });
                                                return (
                                                    <Chip
                                                        key={key}
                                                        label={chip}
                                                        onDelete={() => handleDeleteChip(index)}
                                                        {...tagProps}
                                                    />
                                                );
                                            });
                                        }}
                                        renderInput={(params, index) => <TextField
                                            {...params}
                                            key={index}
                                            label=""
                                            type={constantType === 'number' ? 'number' : 'text'}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter') {
                                                    event.preventDefault();
                                                    handleAddChip();
                                                }
                                            }}
                                            error={!!inputError || !!valueError}
                                            helperText={(inputError ? inputValue : valueError ? valueError : "")}
                                        />}
                                    />
                                ) : (
                                    <Autocomplete
                                        id="constant-single-combo-box"
                                        size='small'
                                        freeSolo
                                        fullWidth
                                        disabled={selectedRadioGroup !== "constant"}
                                        options={constantType?.toLowerCase() === "string" ? otherOptions : []}
                                        value={constantSingleValue ?? null}
                                        inputValue={
                                            constantSingleValue === null || constantSingleValue === undefined
                                                ? ''
                                                : String(constantSingleValue)
                                        }
                                        onInputChange={(event, newInputValue) => {
                                            setConstantSingleValue(newInputValue);
                                            if (isSQLInjection(newInputValue)) {
                                                setValueError("Invalid or inappropriate input.");
                                            } else if (!isValidType(newInputValue)) {
                                                setValueError(`Invalid ${constantType} value`);
                                            } else {
                                                setValueError(null);
                                            }
                                        }}
                                        onChange={(e, newValue) => {
                                            const normalizedValue = newValue === null || newValue === undefined ? '' : String(newValue);
                                            setConstantSingleValue(normalizedValue)
                                            if (isSQLInjection(normalizedValue)) {
                                                setValueError("Invalid or inappropriate input.");
                                            } else if (!isValidType(normalizedValue)) {
                                                setValueError(`Invalid ${constantType} value`);
                                            } else {
                                                setValueError(null);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                type={constantType === 'number' ? 'number' : 'text'}
                                                label=""
                                                error={!!valueError}
                                                helperText={valueError || ""}
                                            />
                                        )}
                                    />
                                )}
                            </ListItem>

                        </Box>

                        <Box flexShrink={0}>
                            {/* Subject Value List */}
                            <ListItem
                                className='bg-gray-200'
                                sx={{
                                    padding: '5px 5px 5px 16px',
                                }}
                            >
                                <ListItemText primary="Subject Value" />
                            </ListItem>
                            <RadioGroup>
                                <ListItem sx={{ paddingY: "10px" }} >
                                    <ListItemIcon sx={{ minWidth: "auto", marginRight: "5px" }}>
                                        <Radio
                                            size="small"
                                            checked={selectedRadioGroup === "subject"}
                                            onChange={() => handleRadioChange("subject")}
                                        />
                                    </ListItemIcon>
                                    <Autocomplete
                                        id="subject-combo-box"
                                        size='small'
                                        fullWidth
                                        disabled={selectedRadioGroup !== "subject"}
                                        options={subjectAttributes}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : (option?.name || "")
                                        }
                                        value={
                                            subjectAttributes.find((option) => option.name === subjectAttributeSelected) || null
                                        }
                                        // onChange={(event, newValue) => handleChange(currentEdit, "value_property", newValue, "subject")}
                                        onChange={(event, newValue) => setSubjectAttributeSelected(newValue?.name || "")}
                                        renderInput={(params) => <TextField {...params} label="" placeholder='Select subject' />}
                                        renderOption={(props, option) => {
                                            const { key, ...rest } = props;
                                            return (
                                                <Box key={key} component="li" {...rest} display="flex" justifyContent="space-between" alignItems="center">
                                                    <span>{option?.name}</span>
                                                    <Chip
                                                        label={option?.attributeType || "-"}
                                                        size="small"
                                                        sx={{ fontSize: '0.6rem', ml: 1 }}
                                                    />
                                                </Box>
                                            );
                                        }}
                                    />
                                </ListItem>
                            </RadioGroup>
                        </Box>

                        <Box flexGrow={1} overflow="hidden" display="flex" flexDirection="column">
                            {/* Parameter List */}
                            <ListItem
                                className='bg-gray-200'
                                sx={{
                                    padding: '5px 16px 5px 16px',
                                }}
                            >
                                <ListItemText
                                    primary={<div className='flex flex-row gap-1'>
                                        <Typography>Parameters (</Typography>
                                        <Checkbox
                                            sx={{
                                                padding: 0,
                                                margin: 0,
                                                width: 'auto',
                                                height: 'auto',
                                            }}
                                            checked={selectedRadioGroup === 'parameter' && requiredParamter}
                                            disabled={selectedRadioGroup !== 'parameter'}
                                            onChange={(e) => handleCheckBoxRequireParameter(e)}
                                        />
                                        <Typography>required)</Typography>
                                    </div>}
                                />
                                <IconButton onClick={handleAddClick}>
                                    <AddCircleOutlineIcon />
                                </IconButton>
                            </ListItem>
                            {showInput && (
                                <ListItem>
                                    <TextField
                                        autoFocus
                                        value={newParameter}
                                        onChange={handleInputChange}
                                        onBlur={handleInputBlur}
                                        onKeyDown={handleInputKeyDown}
                                        label="Enter parameter name"
                                        size="small"
                                        fullWidth
                                        error={errorAddParameter}
                                        helperText={errorAddParameter || ""}
                                    />
                                </ListItem>
                            )}

                            <Box flexGrow={1} overflow="auto">
                                <RadioGroup>
                                    {listParameters.map((attr, index) => (
                                        <ListItem
                                            key={index}
                                            sx={{
                                                backgroundColor: "rgba(0, 0, 0, 0.03)",
                                                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.08)" }
                                            }}
                                        >
                                            <ListItemIcon sx={{ minWidth: "auto", marginRight: "5px" }}>
                                                <Radio
                                                    size="small"
                                                    // checked={selectedRadioGroup === "parameter" && selectedRadioIndex === attr.value}
                                                    checked={selectedRadioGroup === "parameter" && selectedRadioIndex === attr.id}
                                                    // onChange={() => handleRadioChange("parameter", attr.value)}
                                                    onChange={() => handleRadioChange("parameter", attr.id)}
                                                />
                                            </ListItemIcon>
                                            {editIndex === index ? (
                                                <TextField
                                                    autoFocus
                                                    value={editValue}
                                                    onChange={handleEditChange}
                                                    onBlur={handleEditBlur}
                                                    onKeyDown={handleEditKeyDown}
                                                    size="small"
                                                    fullWidth
                                                    error={errorEditParameter}
                                                    helperText={errorEditParameter || ""}
                                                />
                                            ) : (
                                                <ListItemText primary={attr.value} onClick={() => handleRadioChange("parameter", attr.id)} sx={{ cursor: "pointer" }} />
                                            )}
                                            <IconButton onClick={(e) => handleParameterMenuOpen(e, index)}>
                                                <MoreVertIcon />
                                            </IconButton>
                                            <Menu
                                                anchorEl={anchorElParameter}
                                                open={Boolean(anchorElParameter)}
                                                onClose={handleParameterMenuClose}
                                            >
                                                <MenuItem onClick={() => handleEditStart(menuIndex)}>Edit</MenuItem>
                                                <MenuItem onClick={() => handleDelete(menuIndex)}>Delete</MenuItem>
                                            </Menu>
                                        </ListItem>
                                    ))}
                                </RadioGroup>
                            </Box>
                        </Box>

                    </Box>
                }
                actions={
                    <LoadingButton variant="contained" onClick={() => handleChooseValue()} disabled={hasSelected}>Choose</LoadingButton>
                }
            />

            <ConfirmDialogReuse
                open={confirmRemoveParameter}
                maxWidth={"sm"}
                content={
                    <div>
                        <Typography variant="subtitle1">{confirmRemoveParameterMessage}</Typography>
                    </div>
                }
                actions={
                    <div>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                setConfirmRemoveParameter(false);
                                setConfirmRemoveParameterMessage("This parameter is currently in use and cannot be deleted.");
                            }}
                        >
                            OK
                        </Button>
                    </div>
                }
            />

        </Fragment >
    )
}

export default NewCreateConditionDialog